// extracted by mini-css-extract-plugin
export default {"heading":"Ft-z","corrected":"Gt-z","redirectVerbiageContainer":"Ht-z","redirectVerbiageText":"It-z"};